export default "__VITE_ASSET__DdUtFroX__"